export function ThinkingIndicator() {
  return (
    <div className="flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-orange-500/5 to-orange-600/5 border-l-4 border-orange-500/30 rounded-lg">
      <div className="flex space-x-2">
        <div className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"></div>
        <div
          className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
          style={{ animationDelay: "0.1s" }}
        ></div>
        <div
          className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
          style={{ animationDelay: "0.2s" }}
        ></div>
      </div>
      <span className="text-sm text-orange-300 font-medium">Chicky is thinking...</span>
    </div>
  );
}
